import React, { useState } from 'react';

import { Box, Divider } from '@mui/material';

import CampaignsSection from './CampaignsSection';
import OffersSection from './OffersSection';

export default function LoyaltyPayForPointsPage() {
  const [currency, setCurrency] = useState('AUD');

  return (
    <Box>
      <OffersSection currency={currency} onCurrencyChange={setCurrency} />
      <Divider sx={{ my: 4 }} />
      <CampaignsSection />
    </Box>
  );
}
